import { render } from "./Home.vue?vue&type=template&id=24ae2d7e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=24ae2d7e&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__